import { LogLevel } from "@azure/msal-browser";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

const tenantId = import.meta.env.VITE_APP_TENANT_ID;
const clientId = import.meta.env.VITE_APP_CLIENT_ID;
const redirectUri = import.meta.env.VITE_APP_REDIRECT_URL;
const microSoftLogin = import.meta.env.VITE_APP_MICROSOFT_LOGIN;
const microSoftGraphMe = import.meta.env.VITE_APP_MICROSOFT_GRAPH_ME;

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `${microSoftLogin}${tenantId}/`,
    redirectUri: redirectUri,
    postLogoutRedirectUri: null,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) return;

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
    },
  },
};

export const loginScopes = {
  scopes: [`${clientId}/.default`],
};

export const graphConfig = {
  graphMeEndpoint: `${microSoftGraphMe}`,
};
